<template>
  <section class="section instruction">
    <div class="section__container instruction__container">
      <h2 class="section__title instruction__title"
          id="instruction">Как работает Ferma</h2>
      <div class="instruction__content-wrap">
        <div class="instruction__content"></div>
      </div>
      <div class="instruction__action">
        <a class="button" v-scrollTo="'calc'">
          Подключить Ferma
          <img src="../../assets/images/chevron.svg" alt="">
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Instruction'
}
</script>

<style src="./component.scss" scoped lang="scss"/>
